<script lang="ts">
	export let copied = false;

	$: copiedCSS = copied ? '#55DBD7' : '#6B6B6B';
</script>

<div class="cursor-pointer">
	<svg
		role="button"
		tabindex="0"
		on:click
		on:keypress
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="icon-copy">
			<path
				id="Vector (Stroke)"
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M10.8 10.3667C10.2845 10.3667 9.86667 10.7845 9.86667 11.3V19.7C9.86667 20.2155 10.2845 20.6333 10.8 20.6333H19.2C19.7155 20.6333 20.1333 20.2155 20.1333 19.7V11.3C20.1333 10.7845 19.7155 10.3667 19.2 10.3667H10.8ZM8 11.3C8 9.7536 9.2536 8.5 10.8 8.5H19.2C20.7464 8.5 22 9.7536 22 11.3V19.7C22 21.2464 20.7464 22.5 19.2 22.5H10.8C9.2536 22.5 8 21.2464 8 19.7V11.3Z"
				fill={copiedCSS}
			/>
			<path
				id="Vector (Stroke)_2"
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M4.8 4.36667C4.55246 4.36667 4.31507 4.465 4.14003 4.64003C3.965 4.81507 3.86667 5.05246 3.86667 5.3V13.7C3.86667 13.9475 3.965 14.1849 4.14003 14.36C4.31507 14.535 4.55246 14.6333 4.8 14.6333H5.73333C6.2488 14.6333 6.66667 15.0512 6.66667 15.5667C6.66667 16.0821 6.2488 16.5 5.73333 16.5H4.8C4.05739 16.5 3.3452 16.205 2.8201 15.6799C2.295 15.1548 2 14.4426 2 13.7V5.3C2 4.55739 2.295 3.8452 2.8201 3.3201C3.3452 2.795 4.05739 2.5 4.8 2.5H13.2C13.9426 2.5 14.6548 2.795 15.1799 3.3201C15.705 3.8452 16 4.55739 16 5.3V6.23333C16 6.7488 15.5821 7.16667 15.0667 7.16667C14.5512 7.16667 14.1333 6.7488 14.1333 6.23333V5.3C14.1333 5.05246 14.035 4.81507 13.86 4.64003C13.6849 4.465 13.4475 4.36667 13.2 4.36667H4.8Z"
				fill={copiedCSS}
			/>
		</g>
	</svg>
</div>
